import React from "react";
import { Avatar } from "@toddle-edu/ds-web";

const IconAvatar = props => {
  const { icon: Icon, color = "pink" } = props;

  return (
    <Avatar
      icon={<Icon />}
      color={color}
      size="large"
      shape="square"
      theme="light"
      iconType="icon"
      dsVersion="2.0"
    />
  );
};

export default IconAvatar;
